@if (isOpen) {
  <div
    class="modal-overlay"
    (click)="onOverlayClick($event)"
    (keydown.escape)="onClose()"
    tabindex="-1">
    <dialog
      class="modal-container"
      open
      aria-modal="true"
      aria-labelledby="modal-title">
      <div class="modal-header">
        <h2 id="modal-title" class="modal-title">Shipping Details</h2>
        <button class="close-btn" (click)="onClose()" aria-label="Close modal">
          x
        </button>
      </div>
      <div class="modal-content">
        @if (loading | async) {
          <div class="loading-state">Loading shipping details...</div>
        }
        @if (error | async; as errorMessage) {
          <div class="error-state">
            {{ errorMessage }}
          </div>
        }
        @if ((loading | async) === false && (shippingData | async); as data) {
          <div class="table-container">
            <table class="shipping-table">
              <thead>
                <tr>
                  <th>Company Name</th>
                  <th>Distribution Center</th>
                  <th class="text-right">Check Count</th>
                  <th>Expedited</th>
                  <th>Shipping Provider</th>
                  <th class="text-right">Shipping Amount</th>
                  <th>Completed Date</th>
                  <th>Tracking Number</th>
                  <th>Shipping Status</th>
                  <th>Last Updated</th>
                  <th>Est. Delivery Date</th>
                </tr>
              </thead>
              <tbody>
                @for (item of data; track item) {
                  <tr>
                    <td>{{ item.companyName }}</td>
                    <td>{{ item.distributionCenter }}</td>
                    <td class="text-right">{{ item.checkCount }}</td>
                    <td>
                      {{
                        item.expedited
                          ? getExpeditedYesLabel()
                          : getExpeditedNoLabel()
                      }}
                    </td>
                    <td>{{ item.shippingProvider }}</td>
                    <td class="text-right">
                      {{ formatCurrency(item.shippingAmount) }}
                    </td>
                    <td>{{ formatDate(item.completedDate) }}</td>
                    <td>
                      @if (item.trackingNumber && item.trackingUrl) {
                        <a
                          [href]="item.trackingUrl"
                          target="_blank"
                          rel="noopener noreferrer">
                          {{ item.trackingNumber }}
                        </a>
                      }
                      @if (item.trackingNumber && !item.trackingUrl) {
                        <span>
                          {{ item.trackingNumber }}
                        </span>
                      }
                      @if (!item.trackingNumber) {
                        <span>-</span>
                      }
                    </td>
                    <td>
                      <span
                        class="status-badge"
                        [attr.data-status]="item.shippingStatus">
                        {{ getStatusLabel(item.shippingStatus) }}
                      </span>
                    </td>
                    <td>{{ formatDate(item.lastUpdated) }}</td>
                    <td>{{ formatDate(item.estDeliveryDate) }}</td>
                  </tr>
                }
              </tbody>
            </table>
            @if (data.length === 0) {
              <div class="empty-state">No shipping details available.</div>
            }
          </div>
        }
      </div>
    </dialog>
  </div>
}
